export default {
  'work': [
    'Подумать 5 минут над первым шагом по сложной задаче',
    'Открыть почтовый ящик',
    'Написать коллеге с просьбой уточнить детали по задаче',
    'Напомнить коллеге починить проблему',
    'Спросить у директора, удобно ли ему встретиться в понедельник утром',
    'Открыть календарь и найти в нём ближайший свободный слот для...',
    'Подойти к коллеге с вопросом, нужна ли помощь',
    'Подойти к коллеге с вопросом, всё ли понятно',
    'Подойти к коллеге с вопросом, как успехи с задачей',
    'Подумать 15 минут над тем, как работать эффективнее',
    'Запланировать рабочие дела на завтра',
  ],
  'life': [
    'Позвонить другу и спросить, удобно ли ему встретиться в среду вечером',
    'Уточнить у HR-а детали по ДМС',
    'Надеть спортивную форму и выбежать на улицу',
    'Почитать 20 минут развивающую книгу',
    'Погулять на улице 30 минут',
    'Подумать 5 минут, как улучшить сон',
    'Подумать 5 минут, как наладить питание',
    'Подумать 5 минут, как наладить финансы',
    'Подумать 5 минут, как научить себя больше двигаться',
    'Подумать 5 минут, как поддерживать порядок в доме',
    'Подумать над личными целями 15 минут',
    'Подумать 10 минут над тем, что может меня радовать',
    'Позвонить в баню и записаться',
    'Записаться на интересный курс',
    'Позвонить маме просто так',
    'Позвонить папе просто так',
    'Сделать гимнастику для глаз',
    'Выкинуть одну ненужную вещь',
    'Поработать над культурой речи',
    'Подумать как интересно провести выходные',
    'Подумать как провести выходные с пользой',
    'Запланировать личные дела на завтра',
    'Запланировать награды на завтра',
    'Попрактиковать английский',
    'Попрактиковать испанский',
    'Попрактиковать немецкий',
    'Попрактиковать французский',
    'Попрактиковать японский',
    'Попрактиковать язык жестов',
    'Подумать, как сократить расходы',
    'Подумать, как повысить доходы',
  ],
  'reward': [
    'Поиграть в игру',
    'Посмотреть фильм',
    'Сходить в ресторан',
    'Заняться любимым делом',
    'Посмотреть ютуб',
    'Полистать инсту',
    'Полистать тикток',
  ],
};
